module.exports = __webpack_public_path__ + "img/RequestTreeStep_newlogo.9f93a0d9.png";